import { computed, ref, watch } from "vue";
import { getConformityState } from "../infrastructure/api/conformityStatesApi";
import { refusesPseudonymisation } from "../domain/conformityState";
import { logger } from "@/infrastructure/services/LoggerService";
/**
 * Whether a contact is already treated as far as the Pseudonymise action goes. A failed read counts as not treated:
 * the action stays enabled and OPCONF's refusal is what the user then sees.
 */
export function useContactConformityState(contactId, enabled) {
    const state = ref(null);
    let run = 0;
    async function refresh() {
        const current = ++run;
        if (!enabled.value || !contactId.value) {
            state.value = null;
            return;
        }
        try {
            const read = await getConformityState(contactId.value);
            if (current === run) {
                state.value = read;
            }
        }
        catch (error) {
            if (current === run) {
                state.value = null;
            }
            logger.error("Conformity state read failed; the pseudonymise action stays enabled.", error);
        }
    }
    watch([contactId, enabled], () => {
        state.value = null;
        void refresh();
    }, { immediate: true });
    return { alreadyTreated: computed(() => state.value !== null && refusesPseudonymisation(state.value)), refresh };
}
